import { Component } from "@angular/core";
import { AppLayoutComponent } from "../../../shared/components/app-layout/app-layout.component";

@Component({
    selector: "app-terms-and-conditions",
    imports: [AppLayoutComponent],
    templateUrl: "./terms-of-use.component.html",
    styleUrl: "./terms-of-use.component.scss"
})
export class TermsOfUseComponent {}
